import React, { useState } from 'react'

export default function Faq() {

    return (
        <div className='PageContent'>
            <span>FAQ</span>
        </div>
    )
}